var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8.28735C16 12.7056 12.4183 16.2874 8 16.2874C3.58172 16.2874 0 12.7056 0 8.28735C0 3.86908 3.58172 0.287354 8 0.287354C12.4183 0.287354 16 3.86908 16 8.28735ZM6.93934 5.22667C6.64645 5.51956 6.17157 5.51956 5.87868 5.22667C5.58579 4.93377 5.58579 4.4589 5.87868 4.16601C7.05025 2.99443 8.94975 2.99443 10.1213 4.16601C11.2929 5.33758 11.2929 7.23707 10.1213 8.40865C9.72884 8.80113 9.25285 9.06298 8.75 9.19243V9.53732C8.75 9.95154 8.41421 10.2873 8 10.2873C7.58579 10.2873 7.25 9.95154 7.25 9.53732V9.03733C7.25 8.31703 7.81995 7.86561 8.33134 7.75057C8.59823 7.69054 8.8516 7.55704 9.06066 7.34799C9.64645 6.7622 9.64645 5.81245 9.06066 5.22667C8.47487 4.64088 7.52513 4.64088 6.93934 5.22667ZM8 13.2874C8.55228 13.2874 9 12.8396 9 12.2874C9 11.7351 8.55228 11.2874 8 11.2874C7.44771 11.2874 7 11.7351 7 12.2874C7 12.8396 7.44771 13.2874 8 13.2874Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionWhite);
export default __webpack_public_path__ + "static/media/question-white.d7835a81c8c52b2319a8e3b2a084b06c.svg";
export { ForwardRef as ReactComponent };